import ga from '../helpers/ga';
import { lvtMetricEvent } from '.';

export const trackPageLoadTime = (): void => {
  window.addEventListener('load', () => {
    setTimeout(() => {
      const navigationEntries = performance.getEntriesByType('navigation');
      if (navigationEntries.length === 0) return;

      const [timing] = navigationEntries;
      const pageLoadTime = timing.loadEventEnd - timing.startTime;

      ga.sendEvent(
        ...lvtMetricEvent('page_load_time', {
          url: timing.name,
          pageLoadTime,
        })
      );
    });
  });
};
